import { ca } from '@cian/analytics';

import { TCompareType } from '../../types/compareType';

const COMPARE_TYPE_TO_LABEL: Record<TCompareType, string> = {
  default: 'all_parameters',
  differences: 'only_difference',
};

export function trackOnlyDifferencesToggle(compareType: TCompareType) {
  const label = COMPARE_TYPE_TO_LABEL[compareType];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'click',
    label,
  });
}
